module.exports = __webpack_public_path__ + "img/beats-headphones.2538d7f4.png";